"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const thumbup = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-thumbup` : '') + (description ? ` desc-thumbup` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-thumbup"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-thumbup"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.7617 2.40486C13.132 2.40486 14.2473 3.4962 14.2861 4.85712L14.2871 4.93028L14.287 8.71439L20.4172 8.71447C21.1421 8.71555 21.8319 9.02071 22.32 9.55315L22.3776 9.61813C22.8493 10.1686 23.0674 10.8907 22.9817 11.608L22.97 11.6941L21.7223 19.8038C21.5332 21.0422 20.4852 21.9633 19.24 21.9989L19.1651 22H8.83438C8.26618 21.9992 7.70534 21.8757 7.18882 21.638L7.07882 21.5853L6.109 21.0989L2.57151 21.0995C1.75181 21.0995 1.07868 20.4719 1.00642 19.6711L1 19.528L1 11.1865C1 10.3185 1.70359 9.61494 2.57151 9.61494L5.855 9.61486L9.61962 3.59309C10.081 2.85444 10.8903 2.40544 11.7617 2.40486ZM11.7622 3.97637C11.4523 3.97657 11.163 4.12697 10.9845 4.37767L10.9524 4.42584L7.077 10.6249L7.077 19.8269L7.78091 20.1793C8.0791 20.3278 8.40484 20.4118 8.73604 20.4262L8.83554 20.4285H19.1651C19.6488 20.4285 20.0626 20.088 20.1595 19.6184L20.169 19.5657L21.4167 11.4553C21.4616 11.1628 21.3767 10.8653 21.1842 10.6406C21.0045 10.4309 20.7478 10.3041 20.4747 10.2878L20.416 10.286H13.5013C13.0829 10.286 12.7408 9.95886 12.7169 9.54639L12.7156 9.50022L12.7156 4.93028C12.7156 4.40345 12.2885 3.97637 11.7622 3.97637ZM5.50528 11.1862L2.57151 11.1865L2.57151 19.528H5.50528L5.50528 11.1862Z",
    fill: "inherit"
  }));
};
var _default = exports.default = thumbup;